import { render, staticRenderFns } from "./ListSentence.vue?vue&type=template&id=37652b52"
import script from "./ListSentence.vue?vue&type=script&lang=js"
export * from "./ListSentence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports